import { atom } from "jotai";
import { ReactNode } from "react";

export interface Activity {
  activityID: string;
  category: string | null;
  categoryAbbreviation: string | null;
  created: string;
  createdF: string;
  createdSortable: string;
  entryID: string | null;
  finding: string | null;
  findingID: string | null;
  groupID: string;
  hypothesis: string | null;
  hypothesisState: string | null;
  interview: string;
  interviewID: string;
  name: string;
  parentActivityID: string | null;
  targetCategory: string | null;
  targetCategoryAbbreviation: string | null;
  targetEntryID: string | null;
  targetHypothesis: string | null;
  userID: string;
  display?: Display;
}

interface Display {
  title: string;
  subtext: string;
  date: string;
  chip: ReactNode;
}

interface Activities {
  activity: Activity[];
}


const INITIAL_ACTIVITY_IN_ATOM_VALUE: Activity[] = [];


export const activityAtom = atom<Activity[]>(INITIAL_ACTIVITY_IN_ATOM_VALUE);


export const setActivityAtom = (set: Function, value: Activities) => {
    set(activityAtom, value);
};
